import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';



function Footer() {

  return (
    <AppBar position="sticky" sx={{backgroundColor: "white", boxShadow: "none"}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters variant="dense" >
          {/* small screen nav hamburger menu */}
          <Typography
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              color: '#363430',
              textDecoration: 'none',
              fontSize: '11px',
              float: 'right'
            }}
          >
            &#169; 2026 Tyler Syring. All Rights Reserved. pupcals@gmail.com
          </Typography>
          {/* Large view */}
          <Typography
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              color: '#363430',
              textDecoration: 'none',
              fontSize: '11px',
              float: 'right'
            }}
          >
            &#169; 2026 Tyler Syring. All Rights Reserved.
            <a href="mailto:pupcals@gmail.com" style={{ color: "inherit" }}>
              pupcals@gmail.com
            </a>
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Footer;
